import { mq } from '@phishtool/ui';
import styled from 'styled-components';
export const StyledItemsWrapper = styled.div.withConfig({ displayName: "StyledItemsWrapper", componentId: "sc-1my2oos" }) `
  display: flex;
  flex-wrap: wrap;

  ${(props) => mq({
    columnGap: [props.theme.spacers.x3],
    rowGap: [props.theme.spacers.x6, null, props.theme.spacers.x12],
    width: ['100%', null, '80%'],
})}

  & > div {
    ${mq({
    flex: ['100%', 'calc(50% - 18px)'],
})}
  }
`;
export const StyledIconWrapper = styled.div.withConfig({ displayName: "StyledIconWrapper", componentId: "sc-6y78qv" }) `
  ${mq({
    minWidth: ['82px', 'auto'],
})}
`;
